import { configureStore } from '@reduxjs/toolkit'
import userSlice from './reducers/user-reducer'
import settingsSiteSlice from './reducers/settings-site'
import { useDispatch, useSelector, useStore, type TypedUseSelectorHook } from 'react-redux'
const store = configureStore({
  reducer: {
    user: userSlice,
    settings: settingsSiteSlice
  },
})




// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export type AppStore = typeof store

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export const useAppStore: () => AppStore = useStore


export default store


